import Icon from "@/components/primitives/icon";
import TeamLogo from "@/components/team/logo";
import { RecentGames, RecentGamesNew, Sport } from "common";
import React from "react";

export default function RecentGamesMetrics({
  data,
  view,
  sport,
}: {
  data: RecentGamesNew;
  view: string;
  sport: Sport;
}) {
  const last10Record =
    view === "h2h"
      ? data.headToHeadLast10Record
      : view === "away"
      ? data.awayLast10Record
      : data.homeLast10Record;
  const againstSpreadLast10Record =
    view === "h2h"
      ? data.headToHeadAgainstSpreadLast10Record
      : view === "away"
      ? data.awayAgainstSpreadLast10Record
      : data.homeAgainstSpreadLast10Record;
  const totalLast10Record =
    view === "h2h"
      ? data.headToHeadTotalLast10Record
      : view === "away"
      ? data.awayTotalLast10Record
      : data.homeTotalLast10Record;
  return (
    <div className="overflow-x-auto">
      <div className="flex flex-row gap-2 w-full">
        <div className="md:min-w-[226px] w-full bg-surface-600 flex flex-col md:flex-row rounded-xl p-2 md:p-6 justify-between items-start gap-y-0 md:gap-y-2 md:items-end">
          <div className="flex flex-col gap-2 mt-2 p-1 md:p-0">
            <div className="h-px w-6 bg-primary"></div>
            <div className="text-label-sm-medium text-secondary-400 uppercase">
              Win / Loss
            </div>
            <div className="text-display !text-[1.5rem] md:!text-[2rem] text-dark">
              {view === "h2h" ? (
                <>
                  {Math.max(last10Record.wins, last10Record.losses)}-
                  {Math.min(last10Record.wins, last10Record.losses)}-
                  {sport === "nhl"
                    ? last10Record.overtimeLosses
                    : last10Record.ties}
                </>
              ) : (
                <>
                  {last10Record.wins}-{last10Record.losses}-
                  {sport === "nhl"
                    ? last10Record.overtimeLosses
                    : last10Record.ties}
                </>
              )}
            </div>
          </div>
          {view === "h2h" &&
          data.headToHeadLast10Record.wins ===
            data.headToHeadLast10Record.losses ? (
            <div className="flex gap-2 items-center bg-surface rounded-full px-3 h-8 min-w-[84px] justify-center">
              <div className="text-title-lg-medium text-secondary-300">
                TIED
              </div>
            </div>
          ) : (
            <div className="flex gap-2 items-center bg-surface rounded-full px-3 h-8 min-w-[84px] justify-center">
              <TeamLogo
                team={
                  view === "h2h"
                    ? data.last10Outcome === "away"
                      ? data.awayTeam
                      : data.homeTeam
                    : view === "away"
                    ? data.awayTeam
                    : data.homeTeam
                }
                size="xs"
              />
              <div className="text-title-sm-medium md:text-title-lg-medium text-dark">
                {view === "h2h"
                  ? data.last10Outcome === "away"
                    ? data.awayTeam.abbreviation
                    : data.homeTeam.abbreviation
                  : view === "away"
                  ? data.awayTeam.abbreviation
                  : data.homeTeam.abbreviation}
              </div>
            </div>
          )}
        </div>
        <div className="md:min-w-[226px] w-full bg-surface-600 flex flex-col md:flex-row rounded-xl p-2 md:p-6 justify-between items-start gap-y-0 md:gap-y-2 md:items-end">
          <div className="flex flex-col gap-2 mt-2 p-1">
            <div className="h-px w-6 bg-primary"></div>
            <div className="text-label-sm-medium text-secondary-400 uppercase">
              ATS
            </div>
            <div className="text-display !text-[1.5rem] md:!text-[2rem] text-dark">
              {Math.max(
                againstSpreadLast10Record.wins,
                againstSpreadLast10Record.losses
              )}
              -
              {Math.min(
                againstSpreadLast10Record.wins,
                againstSpreadLast10Record.losses
              )}
              -{againstSpreadLast10Record.ties}
            </div>
          </div>
          {view === "h2h" &&
          data.headToHeadAgainstSpreadLast10Record.wins ===
            data.headToHeadAgainstSpreadLast10Record.losses ? (
            <div className="flex gap-2 items-center bg-surface rounded-full px-3 h-8 min-w-[84px] justify-center">
              <div className="text-title-lg-medium text-secondary-300">
                TIED
              </div>
            </div>
          ) : (
            <div className="flex gap-2 items-center bg-surface rounded-full px-3 h-8 min-w-[84px] justify-center">
              <TeamLogo
                team={
                  view === "h2h"
                    ? data.againstSpreadOutcome === "away"
                      ? data.awayTeam
                      : data.homeTeam
                    : view === "away"
                    ? data.awayTeam
                    : data.homeTeam
                }
                size="xs"
              />
              <div className="text-title-lg-medium text-dark">
                {view === "h2h"
                  ? data.againstSpreadOutcome === "away"
                    ? data.awayTeam.abbreviation
                    : data.homeTeam.abbreviation
                  : view === "away"
                  ? data.awayTeam.abbreviation
                  : data.homeTeam.abbreviation}
              </div>
            </div>
          )}
        </div>
        <div className="md:min-w-[226px] w-full bg-surface-600 flex flex-col md:flex-row rounded-xl p-2 md:p-6 justify-between items-start gap-y-0 md:gap-y-2 md:items-end">
          <div className="flex flex-col gap-2 mt-2 p-1">
            <div className="h-px w-6 bg-primary"></div>
            <div className="text-label-sm-medium text-secondary-400 uppercase">
              Total (o/u)
            </div>
            <div className="text-display !text-[1.5rem] md:!text-[2rem] text-dark">
              {totalLast10Record.wins}-{totalLast10Record.losses}-
              {totalLast10Record.ties}
            </div>
          </div>
          {view === "h2h" &&
          data.headToHeadTotalLast10Record.wins ===
            data.headToHeadTotalLast10Record.losses ? (
            <div className="flex gap-2 items-center bg-surface rounded-full px-3 h-8 min-w-[84px] justify-center">
              <div className="text-title-lg-medium text-secondary-300">
                TIED
              </div>
            </div>
          ) : (
            <div className="flex gap-2 items-center bg-surface rounded-full px-3 h-8 min-w-[84px] justify-center">
              <div className="flex items-center gap-1 py-2 px-2">
                {totalLast10Record.wins > totalLast10Record.losses ? (
                  <>
                    <Icon
                      name="arrow-up"
                      className="fill-primary-400"
                      size="xs"
                    />
                    <div className="text-label-lg-bold text-secondary-300 uppercase">
                      Over
                    </div>
                  </>
                ) : (
                  <>
                    <Icon name="arrow-down" className="fill-hot" size="xs" />
                    <div className="text-label-lg-bold text-secondary-300 uppercase">
                      Under
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
